import changePreCheckoutURL from "../../../../graphQl/mutations/changePreCheckoutURL";

export const changePreCheckoutURLQuery = async ({dispatch, commit}, payload) => {
    let changeLangData;
    commit('app/toggleLoading', null, {root: true});
    try {
        changeLangData = await dispatch('app/request', {
            type: 'mutation',
            gql: changePreCheckoutURL,
            variables: payload,
        }, {root: true});
    } catch (error) {
        commit('app/toggleLoading', null, {root: true});
        return error;

    }

    if (changeLangData.message) {
        throw changeLangData.message;
    }

    if (changeLangData.errors) {
        throw changeLangData.errors;
    }
    commit('app/toggleLoading', null, {root: true});
    const {
        data: {
            changePreCheckoutURL: changePreCheckoutURLResponse,
        },
    } = changeLangData;
    return changePreCheckoutURLResponse;

};
